var map = {
	"./template.bet575": 2162,
	"./template.bet575.tsx": 2162,
	"./template.bet777": 2163,
	"./template.bet777.tsx": 2163,
	"./template.betgalaxy": 2164,
	"./template.betgalaxy.tsx": 2164,
	"./template.betprofessor": 2165,
	"./template.betprofessor.tsx": 2165,
	"./template.betroyale": 2166,
	"./template.betroyale.tsx": 2166,
	"./template.betstride": 2167,
	"./template.betstride.tsx": 2167,
	"./template.buffalobet": 2168,
	"./template.buffalobet.tsx": 2168,
	"./template.chromabet": 2169,
	"./template.chromabet.tsx": 2169,
	"./template.default": 672,
	"./template.default.tsx": 672,
	"./template.epicodds": 1629,
	"./template.epicodds.tsx": 1629,
	"./template.fiestabet": 2170,
	"./template.fiestabet.tsx": 2170,
	"./template.forsport": 1630,
	"./template.forsport.tsx": 1630,
	"./template.gigabet": 2171,
	"./template.gigabet.tsx": 2171,
	"./template.goldenbet888": 2172,
	"./template.goldenbet888.tsx": 2172,
	"./template.goldenrush": 2173,
	"./template.goldenrush.tsx": 2173,
	"./template.hyperbet": 2174,
	"./template.hyperbet.tsx": 2174,
	"./template.juicybet": 2175,
	"./template.juicybet.tsx": 2175,
	"./template.junglebet": 2176,
	"./template.junglebet.tsx": 2176,
	"./template.magnumbet": 2177,
	"./template.magnumbet.tsx": 2177,
	"./template.oldgill": 2178,
	"./template.oldgill.tsx": 2178,
	"./template.puntcity": 2179,
	"./template.puntcity.tsx": 2179,
	"./template.puntgenie": 2180,
	"./template.puntgenie.tsx": 2180,
	"./template.pyramidbet": 2181,
	"./template.pyramidbet.tsx": 2181,
	"./template.questbet": 2182,
	"./template.questbet.tsx": 2182,
	"./template.slambet": 2183,
	"./template.slambet.tsx": 2183,
	"./template.sterlingparker": 2184,
	"./template.sterlingparker.tsx": 2184,
	"./template.sugarcastle": 2185,
	"./template.sugarcastle.tsx": 2185,
	"./template.templebet": 2186,
	"./template.templebet.tsx": 2186,
	"./template.titanbet": 2187,
	"./template.titanbet.tsx": 2187,
	"./template.ts": 985,
	"./template.vikingbet": 2188,
	"./template.vikingbet.tsx": 2188,
	"./template.volcanobet": 2189,
	"./template.volcanobet.tsx": 2189,
	"./template.wellbet": 2190,
	"./template.wellbet.tsx": 2190
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2467;